import type { LocalText } from './types';

/** Thai first (main line), English second, as on the menu cards; either may be missing. */
export const main = (t?: LocalText) => t?.th ?? t?.en ?? '';
export const second = (t?: LocalText) => (t?.th && t?.en ? t.en : '');

/** 12000 -> "฿120", 12050 -> "฿120.50" */
export function baht(satang: number): string {
  const v = satang / 100;
  return `฿${v.toLocaleString('en-US', { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 })}`;
}
